import { Input, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { confirmable } from "react-confirm";
import { apiCreateInventoryUnit, apiUpdateIventoryUnit } from "services/unitService";
import "./AddNewUnitDialog.css";
const { TextArea } = Input;
function AddNewUnitDialog(props) {
  const { proceed, show } = props;
  const { selInfo, oldList } = props;
  const [newUnit, setNewUnit] = useState({});
  const { isEdit, title } = props;

  useEffect(()=>{
    if(selInfo !== undefined){
      setNewUnit(selInfo)
    }
  }, [selInfo])
//   console.log(oldList);
  const createNewUnit = () => {
    if (newUnit.name == ""){
      message.error(`Please enter Unit name`);
      return;
    } 
    console.log("oldList-", oldList);
    const newValue = newUnit.name.trim();
    setNewUnit({ ...newUnit, name: newValue });

    if (
      oldList.filter((x) => x.name.toLowerCase() == newValue.toLowerCase())
        .length > 0
    ) {
      message.error(`${newValue} is already in the list`);
      return;
    }
    apiCreateInventoryUnit(newUnit)
        .then((data) => {
            proceed({
              addedItem: data,
            });

        })
        .catch((err) => {
            message.error("There's something wrong while creating Unit. " + err);
        });
  };

  const updateNewUnit = () => {
    if (newUnit.name == ""){
      message.error(`Please enter Unit name`);
      return;
    } 
    console.log("oldList-", oldList);
    const newValue = newUnit.name.trim();
    setNewUnit({ ...newUnit, name: newValue });

    if (
      oldList.filter((x) => x.name.toLowerCase() == newValue.toLowerCase())
        .length > 0
    ) {
      message.error(`${newValue} is already in the list`);
      return;
    }
    apiUpdateIventoryUnit(newUnit)
        .then((data) => {
            proceed({
              addedItem: data,
            });

        })
        .catch((err) => {
            message.error("There's something wrong while creating Unit. " + err);
        });
  };

  const onOKAction = () => {
    if (isEdit === false) {
      createNewUnit()
    }
    else {
      updateNewUnit()
    }
  }
  return (
    <Modal
      visible={show}
      destroyOnClose={true}
      onCancel={() => {
        proceed(null);
      }}
      closable={true}
      maskClosable={false}
      title={title}
      className="custom-unit-new-dialog"
      onOk={onOKAction}
    >
      <div>Please Enter new Unit Name.</div>
      <div style={{ marginTop: 10 }}>name *</div>
      <Input
        value={newUnit.name === undefined ? "":newUnit.name}
        className="normal-input"
        onChange={(e) =>
          setNewUnit({ ...newUnit, name: e.target.value })
        }
      />
    </Modal>
  );
}

export default confirmable(AddNewUnitDialog);
